import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import ClientManagement from './components/ClientManagement/ClientManagement';

const PricelistManagement = () => {
  const { getManagedClients } = PricelistApis();
  const [managedClients, setManagedClients] = useState<string[]>(null);
  const [error, setError] = useState<string>(null);

  useEffect(() => {
    getManagedClients().then((response) => {
      if (response && !response.errorMessage) {
        setManagedClients(response);
      } else {
        setError(response?.errorMessage);
      }
    });
  }, [getManagedClients]);

  return (
    <Box>
      <h2>Pricelist Access Management</h2>
      {error !== null ? <p className="errorMessage">{error}</p> : null}
      {managedClients?.map((m) => (
        <ClientManagement key={m} client={m} />
      ))}
    </Box>
  );
};

export default PricelistManagement;
